import { render, staticRenderFns } from "./CommissionRules.vue?vue&type=template&id=77bed387&scoped=true&"
import script from "./CommissionRules.vue?vue&type=script&lang=ts&"
export * from "./CommissionRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bed387",
  null
  
)

export default component.exports